import script from "./Switch.vue?vue&type=script&setup=true&lang=js"
export * from "./Switch.vue?vue&type=script&setup=true&lang=js"

import "./Switch.vue?vue&type=style&index=0&id=4f5906b8&lang=css"
import "@vueform/toggle/themes/default.css?vue&type=style&index=1&lang=css&external"

const __exports__ = script;

export default __exports__